import React from "react";
import * as styles from "./velavu-alert-modal-title.module.scss";
import Divider from "../divider";

export interface VelavuAlertModalTitleProps {
	children?: React.ReactNode;
}

export default function VelavuAlertModalTitle(
	props: VelavuAlertModalTitleProps,
) {
	return (
		<div className={styles.wrapper}>
			<p className={styles.title}>{props.children}</p>

			<Divider />
		</div>
	);
}
